import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  AddDiscountAPI,
  getSupplierListApi,
} from "../../../../Api/PanelAdminServices";
import TableFixedPage from "../../../TableFixedPage/TableFixedPage";
import Select from "react-select";
import Style from "./AllDiscountProductContainer.module.scss";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
const AllDiscountProductContainer = () => {
  const [loadingType, setLoadingType] = useState(true);
  const [suppliersState, setSuppliersState] = useState(null);
  const [supplierSelectState, setSupplierSelect] = useState(null);
  const [DiscountType, setDiscountType] = useState(null);
  const [disable, setDisable] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onsubmit = (data) => {
    setDisable(true);
    let info = {
      id: 0,
      product_id: 0,
      supplier_id: supplierSelectState.value,
      const: data.CountDiscount === undefined ? 0 : data.CountDiscount,
      precentage: data.PrecentDiscount === undefined ? 0 : data.PrecentDiscount,
    };
    AddDiscountAPI(info, (succ) => {
      if (succ.status === 1) {
        succToast(succ.message);
        setDisable(false);
      } else {
        errorToast(succ.message);
        setDisable(false);
      }
    });
  };
  useEffect(() => {
    getAllSupplierData();
  }, []);
  const getAllSupplierData = async () => {
    getSupplierListApi((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setSuppliersState(res.suppliers);
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
    setLoadingType(false);
  };
  const SupplierChangeHandler = async (value) => {
    setSupplierSelect(value);
    // if (value.label.split(" ").at(-1) === "(رستوران)") {
    //   const resturanCategories = await getFoodCategoryApi(value.value);
    //   setResturanCategoryState(resturanCategories.category);
    //   setSupperMarketCategoryState(null);
    // } else {
    //   const SupermarektCategories = await getSupermarketCategoryApi();
    //   setSupperMarketCategoryState(SupermarektCategories.category);
    //   setResturanCategoryState(null);
    // }
  };

  const DiscountTypeChangeHandler = (e) => {
    setDiscountType(e.target.value);
  };
  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"ایجاد تخفیف روی همه محصولات"} />
      <div className={Style.imgHolder}>
        <img src="/Assets/Images/assignProduct/restaurant.svg" alt="" />
      </div>
      <form onSubmit={handleSubmit(onsubmit)} className={Style.formPart}>
        <div className={Style.inputHolder}>
          <Select
            options={
              suppliersState &&
              suppliersState.map((item) => {
                return {
                  value: item.id,
                  label: `${item.name} ${
                    item.type === "supermarket" ? "(سوپرمارکت)" : "(رستوران)"
                  }`,
                };
              })
            }
            className={Style.selectOptionsearch}
            placeholder={"تامین کننده"}
            onChange={SupplierChangeHandler}
            isLoading={loadingType}
          />

          <select
            name=""
            id=""
            className={errors.maxCount ? Style.errorInput : Style.inputPart}
            onChange={DiscountTypeChangeHandler}
          >
            <option value="0">نوع تخفیف انتخاب کنید</option>
            <option value="2">درصد</option>
            <option value="1">مقدار</option>
          </select>
          {DiscountType === "1" ? (
            <input
              className={errors.maxCount ? Style.errorInput : Style.inputPart}
              placeholder={"مقدار تخفیف"}
              {...register("CountDiscount", { required: true })}
            />
          ) : DiscountType === "2" ? (
            <input
              className={errors.price ? Style.errorInput : Style.inputPart}
              placeholder={"درصد تخفیف"}
              {...register("PrecentDiscount", { required: true })}
            />
          ) : null}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
          }}
        >
          <button className={Style.btnStyle} type={"submit"} disabled={disable}>
            ثبت
          </button>
        </div>
      </form>
    </div>
  );
};

export default AllDiscountProductContainer;
